// extracted by mini-css-extract-plugin
module.exports = {"confirmBtn":"styles-module__confirmBtn___3l571","affirmBtn":"styles-module__affirmBtn___3z-im","cancelBtn":"styles-module__cancelBtn___1VN31"};